
import React from 'react';
import { useIsMobile } from "@/hooks/use-mobile";
import { ChallengeHeroContent } from './hero/ChallengeHeroContent';
import { MoviePoster } from './hero/MoviePoster';
import { useCountdown } from './hero/useCountdown';

interface ChallengeHeroProps {
  title: string;
  description: string;
  rightHolderLogo: string;
  moviePoster: string;
  platform: string;
  cashPrize: string;
  cpmPayout: string;
  startDate: string;
  isCompleted?: boolean;
  completionDate?: string;
}

const ChallengeHero: React.FC<ChallengeHeroProps> = ({
  title,
  description,
  rightHolderLogo,
  moviePoster,
  platform,
  cashPrize,
  cpmPayout,
  startDate,
  isCompleted = false,
  completionDate
}) => {
  const isMobile = useIsMobile();
  // Set the launch date to April 25, 2025 at 8am Paris time (CEST)
  const launchDate = new Date('2025-04-25T08:00:00+02:00');
  const timeLeft = useCountdown(launchDate);

  return (
    <section className="relative py-12 md:py-20 px-4 md:px-6 overflow-hidden">
      {/* Removed challenge completed banner */}
      
      <div className="absolute inset-0 bg-gradient-to-b from-primary/10 via-primary/5 to-transparent"></div>
      
      <div className="max-w-6xl mx-auto relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-center">
          <ChallengeHeroContent
            title={title}
            timeLeft={timeLeft}
            cashPrize={cashPrize}
            cpmPayout={cpmPayout}
            isCompleted={isCompleted}
            completionDate={completionDate}
          />
          
          <MoviePoster
            moviePoster={moviePoster}
            title={title}
          />
        </div>
      </div>
    </section>
  );
};

export default ChallengeHero;
